/**
 * SmswiserCampaignDetailPage constants
 * For Media Devoted | Created By Ciro Autiero
 */

export const DEFAULT_PREPARED_CAMPAIGN_NAME = 'AU_CASINO_MAINFLOW_CONSTANT';

export const STATS_SUB_TABS = [
  'drops',
  'texts',
  'lists',
  'gateways',
  'sources',
  'phone',
  'deployed',
  'paths',
  'landers',
  'offers',
  'flow',
  'scheduler',
  'automation',
] as const;

/** Which of these a tracker shows: tracker/stats-sub-tabs.ts (Voluum and Binom: all). */
export type StatsSubTab = (typeof STATS_SUB_TABS)[number];

export function getDefaultPreparedCampaignId(
  campaigns: Array<{ id: number; name: string }>,
): number | null {
  if (campaigns.length === 0) return null;
  const preferred = campaigns.find((c) => c.name === DEFAULT_PREPARED_CAMPAIGN_NAME);
  return preferred?.id ?? campaigns[0]!.id;
}
